<template>
    <div ref="wrap" class="v-uploader-iframe" @mouseenter="handleWrapEnter">
        <form ref="form" :action="postUrl" :target="frameName" enctype="multipart/form-data" method="POST">
            <input type="hidden" />
            <input
                ref="core"
                type="file"
                name="lbf-file-upload"
                class="v-uploader__core"
                :style="inputStyle"
                :disabled="disabled"
                @change="handleFileChange"
                @mouseleave="handleCoreLeave"
            />
            <span v-show="false" ref="dataSpan"></span>
        </form>
        <template v-if="!draggable">
            <slot>
                <button class="v-uploader__defaultFace">选择文件</button>
            </slot>
        </template>
        <template v-else>
            <v-uploader-dnd-area>
                <slot>
                    <p>当前浏览器不支持拖拽上传，请使用点击选择文件，或更新浏览器</p>
                </slot>
            </v-uploader-dnd-area>
        </template>
        <iframe ref="iframe" :name="frameName" style="display:none;" src="javascript:false;"></iframe>
    </div>
</template>

<script>
import VUploaderDndArea from './uploader-dnd-area.vue';
import * as Dom from './utils/dom';
import Constants from './constants';

const FRAME_NAME_PRE = 'IFRAME-UPLOADER';
const CALLBACK_NAME_PRE = 'IFRAMEUPLOADER';
const { STATUS } = Constants;

export default {
    name: 'VUploaderIframe',
    components: {
        VUploaderDndArea
    },
    props: {
        kind: {
            type: String,
            default: 'normal'
        },
        url: {
            type: String,
            required: true
        },
        sizeLimit: {
            type: String,
            default: '2MB'
        },
        sizeNumKb: {
            type: Number,
            default: 2048
        },
        typeLimit: {
            type: String,
            default: '*.jpg;*.gif;*.jpeg;*.png;*.bmp'
        },
        typeReg: {
            type: RegExp,
            default: () => new RegExp()
        },
        withCredentials: Boolean,
        disabled: Boolean,
        draggable: Boolean
    },
    data() {
        const now = Date.now();

        return {
            frameName: FRAME_NAME_PRE + now,
            callbackName: CALLBACK_NAME_PRE + now,
            uploading: false,
            mockprogress: 0,
            mockProgressPId: 0,
            checkFailTimer: 0,
            inputStyle: {
                position: 'absolute',
                filter: 'alpha(opacity: 0)',
                opacity: 0,
                top: '-9999px',
                left: '-9999px'
            }
        };
    },
    computed: {
        postUrl() {
            let result = '';
            if (this.url.indexOf('?') === -1) {
                result = `${this.url}?type=upload&cb=?`;
            } else if (this.url.indexOf('type=upload&cb=') === -1) {
                result = `${this.url}&type=upload&cb=?`;
            } else {
                result = this.url;
            }
            result = result.replace('=?', `=${this.callbackName}`);
            return result;
        }
    },
    mounted() {
        const inputForm = this.$refs.form;
        const { iframe } = this.$refs;
        // move inner form out of component dom, to support native form submit
        document.body.appendChild(inputForm);

        // window.addEventListener('message', this.receiveMessage, false);

        // 处理服务器没有处理的情况
        iframe.onload = () => {
            if (this.uploading === true) {
                this.checkFailTimer = setTimeout(() => {
                    this._clearMockProgress();
                    // eslint-disable-next-line no-multi-assign
                    this.$parent.onlyFile.percentage = this.mockprogress = 0;
                    this.$emit('formUploaded', {
                        file: this.$parent.onlyFile,
                        origin: {
                            error: true,
                            message: '服务器错误'
                        }
                    });
                    this.$parent.onlyFile.status = STATUS.ERROR;

                    this.callbackName = null;
                    // update callback name for next use
                    this.callbackName = CALLBACK_NAME_PRE + Date.now();
                    this.uploading = false;
                    this.resetFileInput();
                }, 3000); // 设置3秒超时时间，上传service返回3秒后postMessage没有正常处理，则认定超时出错
            }
        };
    },
    methods: {
        handleFileChange(evt) {
            const input = evt.target || evt.srcElement;
            const fullName = input.value;
            const mockFiles = [
                {
                    name: fullName ? fullName.substring(fullName.lastIndexOf('\\') + 1) : ''
                }
            ];
            this.$emit('file', mockFiles);
        },
        handleWrapEnter() {
            // update input file style to cover wrap
            this.updateCoreStyle();
        },
        handleCoreLeave() {
            this.inputStyle.top = '-9999px';
            this.inputStyle.left = '-9999px';
        },
        resetFileInput() {
            this.$refs.form.reset();
        },
        postFile(file) {
            this._sendFiles(file);
        },

        checkFileType(file) {
            const coreInput = this.$refs.core;
            const filePath = coreInput.value;
            const type = filePath.substring(filePath.lastIndexOf('.') + 1);
            const flag = this.typeReg.test(type);

            if (!flag) {
                file.error = {
                    type: 'TYPE',
                    message: 'File type invalid'
                };
            }

            return flag;
        },
        checkFileSize(file) {
            let size = file ? (file.size || 0) / 1024 : -1;
            const coreInput = this.$refs.core;
            // iE10以下 不支持file接口 拿不到filesize
            try {
                const oas = new window.ActiveXObject('Scripting.FileSystemObject');
                const filepath = coreInput.value;
                size = oas.getFile(filepath).size;
            } catch (e) {
                console.log(e);
            }
            const flag = this.sizeNumKb === 0 || size <= this.sizeNumKb;

            if (!flag) {
                file.error = {
                    type: 'SIZE',
                    message: 'File size exceed'
                };
            }

            return flag;
        },
        _sendFiles(file) {
            if (this.uploading) {
                return;
            }
            this.uploading = true;

            const { form } = this.$refs;
            const { dataSpan } = this.$refs;

            const inputs = [];

            inputs.push(`<input name="file_size_limit" value="${this.sizeLimit}"/>`);
            inputs.push(`<input name="file_types" value="${this.typeLimit}"/>`);

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.data) {
                if (Object.prototype.hasOwnProperty.call(this.data, key)) {
                    inputs.push(`<input name="${key}" value="${this.data[key]}"/>`);
                }
            }
            dataSpan.innerHTML = inputs.join('');

            window[this.callbackName] = res => {
                clearTimeout(this.checkFailTimer);
                this._clearMockProgress();
                this.$emit('formUploaded', {
                    file,
                    origin: res
                });

                window[this.callbackName] = null;
                // update callback name for next use
                this.callbackName = CALLBACK_NAME_PRE + Date.now();
                this.uploading = false;
                this.resetFileInput();
            };

            form.submit();
            dataSpan.innerHTML = '';

            // cancel function
            file.cancelFunc = () => {
                // window[this.callbackName] = () => {};
                // update callback name for next use
                this.callbackName = CALLBACK_NAME_PRE + Date.now();
                this.uploading = false;
                this._clearMockProgress();
            };

            // mock progress
            this.mockProgressId = setInterval(() => {
                this.mockprogress = this.mockprogress < 90 ? this.mockprogress + 10 : 99;
                file.percentage = this.mockprogress;
                this.$emit('progress', {
                    file,
                    origin: {
                        loaded: this.mockprogress,
                        total: 100
                    }
                });

                if (this.mockprogress === 99) {
                    this._clearMockProgress();
                }
            }, 500);
        },
        receiveMessage(evt) {
            const msg = evt || window.event; // 兼容IE8
            const loc = window.location;
            let data;

            try {
                data = JSON.parse(msg.data);
            } catch (e) {
                data = {};
            }

            if (!data.id || data.id !== this.callbackName || evt.origin !== `${loc.protocol}//${loc.host}`) {
                return;
            }

            clearTimeout(this.checkFailTimer);
            this._clearMockProgress();
            // eslint-disable-next-line no-multi-assign
            this.$parent.onlyFile.percentage = this.mockprogress = 0;
            this.$emit('formUploaded', {
                file: this.$parent.onlyFile,
                origin: data
            });

            this.callbackName = null;
            // update callback name for next use
            this.callbackName = CALLBACK_NAME_PRE + Date.now();
            this.uploading = false;
            this.resetFileInput();
        },
        _clearMockProgress() {
            clearInterval(this.mockProgressId);
            this.mockProgressId = 0;
        },
        updateCoreStyle() {
            const inputWrap = this.$refs.wrap;
            const wrapRect = Dom.getRect(inputWrap);
            this.inputStyle = {
                position: 'absolute',
                'font-size': '250px',
                filter: 'alpha(opacity: 0)',
                opacity: 0,
                'z-index': 10,
                width: `${wrapRect.width}px`,
                height: `${wrapRect.height}px`,
                top: `${wrapRect.top}px`,
                left: `${wrapRect.left}px`
            };
        }
    }
};
</script>
